import React from "react"

const Connector1 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="34"
    height="247"
    viewBox="0 0 34 247"
  >
    <g id="Group_157" data-name="Group 157" transform="translate(-141 -1650)">
      <g
        id="Ellipse_3"
        data-name="Ellipse 3"
        transform="translate(141 1650)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_4"
        data-name="Ellipse 4"
        transform="translate(141 1695)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_5"
        data-name="Ellipse 5"
        transform="translate(161 1744)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_8"
        data-name="Ellipse 8"
        transform="translate(161 1883)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_6"
        data-name="Ellipse 6"
        transform="translate(161 1789)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_7"
        data-name="Ellipse 7"
        transform="translate(141 1835)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <line
        id="Line_12"
        data-name="Line 12"
        y2="32"
        transform="translate(148.5 1663.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <path
        id="Path_7196"
        data-name="Path 7196"
        d="M0,0V127.006"
        transform="translate(148.5 1708.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <path
        id="Path_7198"
        data-name="Path 7198"
        d="M0,0V32"
        transform="translate(168.5 1757.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <path
        id="Path_7199"
        data-name="Path 7199"
        d="M119.825,1689.262l14.9,10.256v26.51"
        transform="translate(33 18)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <path
        id="Path_7200"
        data-name="Path 7200"
        d="M119.825,1689.262l14.9,10.256v26.51"
        transform="translate(33 157)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
    </g>
  </svg>
)

export default Connector1
